'use strict';

/* global yith_wcaf */

import YITH_WCAF_Admin_Modal from './yith-wcaf-admin-modal';
import YITH_WCAF_Admin_Tabs from './yith-wcaf-admin-tabs';

export default class YITH_WCAF_Admin_Tabbed_Modal extends YITH_WCAF_Admin_Modal {
	// tabs
	$tabs = null;

	constructor( $opener, args ) {
		super( $opener, {
			classes: {
				wrap: 'yith-wcaf-modal',
				main: 'tabbed-modal tabbed-content',
			},
			...args,
		} );
	}

	onOpen() {
		super.onOpen();

		this.tab = new YITH_WCAF_Admin_Tabs( this.modal.elements.wrap );
	}
}
